function brandTextTruncation() {
    const title  = document.getElementById('brand__title');
    const content = document.getElementById('brand__text');
    
    if(content.innerHTML == '') {
      title.classList.remove('hidden');
      title.classList.add('fade-in');
      return;
    }
    
    const toggle = document.getElementById('brand__text-toggle');
    const readMoreText = toggle.getAttribute('data-more-text');
    const readLessText = toggle.getAttribute('data-less-text');
  
    var brandWordLimit = 30;
    if(getBrowserWidth() < 768) {
      var brandWordLimit = 20;
    }

    const originalContent = content.innerHTML;
    const { truncatedContent, requiresTruncation } = truncateText(content, brandWordLimit);

    function insertToggleButton(text) {
      const tempDiv = document.createElement('div');
      tempDiv.innerHTML = text;
      const lastParagraph = tempDiv.querySelector('p:last-child');
      if (lastParagraph) {
        lastParagraph.innerHTML += '<span class="button-placeholder"></span>';
      } else {
        tempDiv.innerHTML += '<span class="button-placeholder"></span>';
      }
      return tempDiv.innerHTML;
    }
  
    const originalContentWithPlaceholder = insertToggleButton(originalContent);
  
    if(requiresTruncation) {
      content.innerHTML = truncatedContent.trim();
      const buttonPlaceholder = content.querySelector('.button-placeholder');
      if (buttonPlaceholder) {
        buttonPlaceholder.replaceWith(toggle);
      }
      toggle.classList.remove('hidden');
      toggle.classList.add('fade-in');
    } else {
      toggle.remove();
    }
    content.classList.remove('hidden');
    content.classList.add('fade-in');
    title.classList.remove('hidden');
    title.classList.add('fade-in');
  
    let isTruncated = true;
  
    toggle.addEventListener("click", function() {
      if (isTruncated) {
        content.innerHTML = originalContentWithPlaceholder;
        const buttonPlaceholder = content.querySelector('.button-placeholder');
        if (buttonPlaceholder) {
          buttonPlaceholder.replaceWith(toggle);
        } else {
          content.appendChild(toggle);
        }
        this.textContent = readLessText;
      } else {
        content.innerHTML = truncatedContent;
        this.textContent = readMoreText;
        const buttonPlaceholder = content.querySelector('.button-placeholder');
        if (buttonPlaceholder) {
          buttonPlaceholder.replaceWith(toggle);
        } else {
          content.appendChild(toggle);
        }
      }
      isTruncated = !isTruncated;
    });
    
  };
  
  function getBrowserWidth() {
    return window.innerWidth;
  }
  
  function countWords(str) {
    return str.split(/\s+/).filter(function(word) {
      return word.length > 0;
    }).length;
  }
  
  function truncateText(element, wordLimit) {
    const originalContent = element.innerHTML;
    const tempElement = document.createElement('div');
    tempElement.innerHTML = originalContent;
  
    let wordCount = 0;
    let truncatedContent = '';
  
    function processNode(node) {
      if (wordCount >= wordLimit) return;
      if (node.nodeType === Node.TEXT_NODE) {
        const nodeWords = node.textContent.split(/\s+/).filter(Boolean);
        if (wordCount + nodeWords.length <= wordLimit) {
          truncatedContent += node.textContent;
          wordCount += nodeWords.length;
        } else {
          const remainingWords = wordLimit - wordCount;
          truncatedContent += nodeWords.slice(0, remainingWords).join(' ') + '<span class="ellipsis">...</span><span class="button-placeholder"></span>';
          wordCount = wordLimit;
        }
      } else if (node.nodeType === Node.ELEMENT_NODE) {
        const clonedNode = node.cloneNode(false);
        truncatedContent += `<${node.tagName.toLowerCase()}${[...node.attributes].map(attr => ` ${attr.name}="${attr.value}"`).join('')}>`;
        node.childNodes.forEach(childNode => processNode(childNode));
        truncatedContent += `</${node.tagName.toLowerCase()}> `;
      }
    }
  
    tempElement.childNodes.forEach(processNode);
    truncatedContent = truncatedContent.trim();
    return { truncatedContent, requiresTruncation: wordCount >= wordLimit };
  }
  
  if (Shopify.designMode) {
    document.addEventListener("shopify:section:load", brandTextTruncation);
  }
  document.addEventListener("DOMContentLoaded", brandTextTruncation);